
// THIS FILE IS AUTOGENERATED AS PART OF THE EXTENSION AND MODE PLUGIN PROCESS.
// IT SHOULD NOT BE MODIFIED MANUALLY 
import {
  isRuntimeDescriptor,
  loadRuntimeDescriptor,
  resolveRuntimeModule,
  loadExternalModule,
  sharePlugin,
  loadInPhases,
} from './runtimeExtensionLoader';

const extensions = [];
const modes = [];

// Not required any longer
window.extensions = extensions;
window.modes = modes;

extensions.push("@ohif/extension-default");
extensions.push("@ohif/extension-cornerstone");
extensions.push("@ohif/extension-ultrasound-pleura-bline");
modes.push("@ohif/mode-longitudinal");
modes.push("@ohif/mode-basic");
modes.push("@ohif/mode-segmentation");
modes.push("@ohif/mode-tmtv");
modes.push("@ohif/mode-microscopy");
modes.push("@ohif/mode-preclinical-4d");
modes.push("@ohif/mode-ultrasound-pleura-bline");


// The extensions and modes declared in pluginConfig.json. A runtime
// descriptor reusing one of these names is refused before anything is
// fetched, so the built-in copy always wins (see loadRuntimeDescriptor).
const builtInPlugins = new Set(["@ohif/extension-default","@ohif/extension-cornerstone","@ohif/extension-measurement-tracking","@ohif/extension-cornerstone-dicom-sr","@ohif/extension-cornerstone-dicom-seg","@ohif/extension-cornerstone-dicom-pmap","@ohif/extension-cornerstone-dynamic-volume","@ohif/extension-dicom-microscopy","@ohif/extension-dicom-pdf","@ohif/extension-dicom-video","@ohif/extension-tmtv","@ohif/extension-test","@ohif/extension-cornerstone-dicom-rt","@ohif/extension-ultrasound-pleura-bline","@ohif/mode-longitudinal","@ohif/mode-basic","@ohif/mode-segmentation","@ohif/mode-tmtv","@ohif/mode-microscopy","@ohif/mode-preclinical-4d","@ohif/mode-test","@ohif/mode-basic-dev-mode","@ohif/mode-ultrasound-pleura-bline"]);

// Add a dynamic runtime loader
// kind ('extension' | 'mode') says which app-config list a descriptor came
// from; it is recorded on the descriptor's audit record.
async function loadModule(module, kind) {
  // Runtime descriptors from window.config.extensions / .modes ({ packageName, importPath, ... })
  if (isRuntimeDescriptor(module)) return loadRuntimeDescriptor(module, builtInPlugins, kind);
  if (Array.isArray(module) && isRuntimeDescriptor(module[0])) {
    return [await loadRuntimeDescriptor(module[0], builtInPlugins, kind), module[1]];
  }
  if (typeof module !== 'string') return module;
  if( module==="@ohif/extension-default") {
    const imported = await import("@ohif/extension-default");
    return sharePlugin("@ohif/extension-default", imported).default;
  }
  if( module==="@ohif/extension-cornerstone") {
    const imported = await import("@ohif/extension-cornerstone");
    return sharePlugin("@ohif/extension-cornerstone", imported).default;
  }
  if( module==="@ohif/extension-measurement-tracking") {
    const imported = await import("@ohif/extension-measurement-tracking");
    return sharePlugin("@ohif/extension-measurement-tracking", imported).default;
  }
  if( module==="@ohif/extension-cornerstone-dicom-sr") {
    const imported = await import("@ohif/extension-cornerstone-dicom-sr");
    return sharePlugin("@ohif/extension-cornerstone-dicom-sr", imported).default;
  }
  if( module==="@ohif/extension-cornerstone-dicom-seg") {
    const imported = await import("@ohif/extension-cornerstone-dicom-seg");
    return sharePlugin("@ohif/extension-cornerstone-dicom-seg", imported).default;
  }
  if( module==="@ohif/extension-cornerstone-dicom-pmap") {
    const imported = await import("@ohif/extension-cornerstone-dicom-pmap");
    return sharePlugin("@ohif/extension-cornerstone-dicom-pmap", imported).default;
  }
  if( module==="@ohif/extension-cornerstone-dynamic-volume") {
    const imported = await import("@ohif/extension-cornerstone-dynamic-volume");
    return sharePlugin("@ohif/extension-cornerstone-dynamic-volume", imported).default;
  }
  if( module==="@ohif/extension-dicom-microscopy") {
    const imported = await import("@ohif/extension-dicom-microscopy");
    return sharePlugin("@ohif/extension-dicom-microscopy", imported).default;
  }
  if( module==="@ohif/extension-dicom-pdf") {
    const imported = await import("@ohif/extension-dicom-pdf");
    return sharePlugin("@ohif/extension-dicom-pdf", imported).default;
  }
  if( module==="@ohif/extension-dicom-video") {
    const imported = await import("@ohif/extension-dicom-video");
    return sharePlugin("@ohif/extension-dicom-video", imported).default;
  }
  if( module==="@ohif/extension-tmtv") {
    const imported = await import("@ohif/extension-tmtv");
    return sharePlugin("@ohif/extension-tmtv", imported).default;
  }
  if( module==="@ohif/extension-test") {
    const imported = await import("@ohif/extension-test");
    return sharePlugin("@ohif/extension-test", imported).default;
  }
  if( module==="@ohif/extension-cornerstone-dicom-rt") {
    const imported = await import("@ohif/extension-cornerstone-dicom-rt");
    return sharePlugin("@ohif/extension-cornerstone-dicom-rt", imported).default;
  }
  if( module==="@ohif/extension-ultrasound-pleura-bline") {
    const imported = await import("@ohif/extension-ultrasound-pleura-bline");
    return sharePlugin("@ohif/extension-ultrasound-pleura-bline", imported).default;
  }
  if( module==="@ohif/mode-longitudinal") {
    const imported = await import("@ohif/mode-longitudinal");
    return sharePlugin("@ohif/mode-longitudinal", imported).default;
  }
  if( module==="@ohif/mode-basic") {
    const imported = await import("@ohif/mode-basic");
    return sharePlugin("@ohif/mode-basic", imported).default;
  }
  if( module==="@ohif/mode-segmentation") {
    const imported = await import("@ohif/mode-segmentation");
    return sharePlugin("@ohif/mode-segmentation", imported).default;
  }
  if( module==="@ohif/mode-tmtv") {
    const imported = await import("@ohif/mode-tmtv");
    return sharePlugin("@ohif/mode-tmtv", imported).default;
  }
  if( module==="@ohif/mode-microscopy") {
    const imported = await import("@ohif/mode-microscopy");
    return sharePlugin("@ohif/mode-microscopy", imported).default;
  }
  if( module==="@ohif/mode-preclinical-4d") {
    const imported = await import("@ohif/mode-preclinical-4d");
    return sharePlugin("@ohif/mode-preclinical-4d", imported).default;
  }
  if( module==="@ohif/mode-test") {
    const imported = await import("@ohif/mode-test");
    return sharePlugin("@ohif/mode-test", imported).default;
  }
  if( module==="@ohif/mode-basic-dev-mode") {
    const imported = await import("@ohif/mode-basic-dev-mode");
    return sharePlugin("@ohif/mode-basic-dev-mode", imported).default;
  }
  if( module==="@ohif/mode-ultrasound-pleura-bline") {
    const imported = await import("@ohif/mode-ultrasound-pleura-bline");
    return sharePlugin("@ohif/mode-ultrasound-pleura-bline", imported).default;
  }
  if( module==="dicom-microscopy-viewer") {
    const imported = await window.browserImportFunction('/dicom-microscopy-viewer/dicomMicroscopyViewer.min.js');
    return window["dicomMicroscopyViewer"];
  }
  // A plugin a runtime descriptor already loaded, looked up by bare name (Mode.tsx dependencies)
  const runtimeModule = resolveRuntimeModule(module);
  if (runtimeModule !== undefined) return runtimeModule;
  // Fallthrough: a URL on an allowlisted origin is imported directly; unknown bare
  // names throw a descriptive error (see runtimeExtensionLoader.ts).
  return loadExternalModule(module);
}

// Import a list of items (modules or string names): compiled-in plugins
// first, then runtime descriptors (see loadInPhases).
// @param kind 'extension' or 'mode', recorded on runtime descriptors' audit records
// @return a Promise evaluating to a list of modules, in input order
export default function importItems(modules, kind) {
  return loadInPhases(modules, module => loadModule(module, kind));
}

export { loadModule, modes, extensions, importItems };

